(function () {
    'use strict';

    // @ngInject
    function SettingsSecondLevelNavigationControllerCtor($scope, $injector, $state, AppStates, UsersManager, AuthService, AnalyticsService, OnboardingService, ModalService, FeaturesService) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'SettingsSecondLevelNavigationController';

        this.$state = $state;
        this.AppStates = AppStates;
        this.AuthService = AuthService;
        this.AnalyticsService = AnalyticsService;
        this.ModalService = ModalService;

        this.user = UsersManager.getCurrUser();

        // prepare the view model
        this.title = $state.$current.data.title;

        // company settings links
        this.navItems = [
            {linkTitleKey: 'Company Brand', stateToGoto: AppStates.root_core_navigation_settings_company_general},
            {linkTitleKey: 'Integrations', stateToGoto: AppStates.root_core_navigation_settings_company_integrations},
            {linkTitleKey: 'Team', stateToGoto: AppStates.root_core_navigation_settings_company_team},
            {linkTitleKey: 'Preferences', stateToGoto: AppStates.root_core_navigation_settings_company_preferences}
        ];

        // add routes for company owner only
        if (this.user.isCompanyOwner()) {

            // membership
            if (this.user.shouldShowMembershipToUser()) {

                this.navItems.push({
                    linkTitleKey: 'Membership',
                    stateToGoto: AppStates.root_core_navigation_settings_company_subscription
                });
            }
            // bank details
            this.navItems.push({
                linkTitleKey: 'Bank Details',
                stateToGoto: AppStates.root_core_navigation_settings_company_bankInfo
            });
        }

        if (this.user.shouldShowClientPortal()) {
            this.navItems.splice(1, 0, {linkTitleKey: 'Client Portal', stateToGoto:AppStates.root_core_navigation_settings_company_client_portal});
        }
    }

    Controllers.SettingsSecondLevelNavigationController = Class(Controllers.BaseController, {
        constructor: SettingsSecondLevelNavigationControllerCtor,

        onMenuItemClicked: function onMenuItemClicked(stateToGoto) {
            this.goToState(stateToGoto);
        },

        onUploadIconClick: function onUploadIconClick() {
            this.ModalService.openUploadIconPhotoModal(this.user.company);
        },

        logout: function logout() {
            this.AuthService.logout();
        },

        activeState: function activeState(route) {
            return route === this.$state.current.name;
        },

        findRootIndex: function findMenuItem(item) {
            return item.linkTitleKey === 'Integrations';
        }

    });
}());

